import TiptapForm from "../components/common/input-layout/tiptap/TiptapForm";
import DateInput from "../components/common/input-layout/DateInput";


export default function FormInputs({
    type,
    name,
    label,
    id,
    options,
    placeholder,
    value,
    onChange,
    onChangeHtml,
    required,
    multiple,
    childId,
    disabled,
    pattern,
    handleFileChange,
    handleFileUpload,
    defaultOpt,
    defaultOptName,
    className,
    content
}) {
    const imageFolder = process.env.REACT_APP_LOCAL_ASSETS_BASE_URL;

    value = value != null ? value : "";
    switch (type) {
        case "number":
            return (
                <div className={`form-input ${name} ${className ? className : ""}`}>
                    <label htmlFor={name} className={required && "required"}>{label}</label>
                    <input
                        key={name + id}
                        type="number"
                        name={name}
                        id={id}
                        value={value}
                        placeholder={placeholder}
                        onChange={onChange}
                        required={required}
                        pattern={pattern}
                    />
                </div>
            )
        case "colorpicker":
            return (
                <div className={`form-input ${name} ${className ? className : ""}`}>
                    <label htmlFor={name} className={required && "required"}>{label}</label>
                    <input
                        key={name + id}
                        type="color"
                        name={name}
                        id={id}
                        value={value}
                        placeholder={placeholder}
                        onChange={onChange}
                        required={required}
                        disabled={disabled}
                    />
                </div>
            )
        case "html":
            return (
                <div className={`form-input ${name}  ${className ? className : ""} html-textarea tiptap-form`}>
                    <label htmlFor={name} className={required && "required"}>{label}</label>
                    <TiptapForm onChange={onChangeHtml} content={content} />
                </div>
            )
        case "email":
            return (
                <div className={`form-input ${name} ${className ? className : ""}`}>
                    <label htmlFor={name} className={required && "required"}>{label} </label>
                    <input
                        key={name + id}
                        type="email"
                        name={name}
                        id={id}
                        value={value}
                        placeholder={placeholder}
                        onChange={onChange}
                        required={required}
                        pattern={pattern}
                    />
                </div>
            )
        case "textarea":
            return (
                <div className={`form-input ${name} ${className ? className : ""}`}>
                    <label htmlFor={name} className={required && "required"}>{label}</label>
                    <textarea
                        key={name + id}
                        name={name}
                        id={id}
                        value={value}
                        placeholder={placeholder}
                        onChange={onChange}
                        className="form-inputs-textarea"
                    />
                </div>
            )
        case "date":
            return (
                <div className={`form-input ${name} ${className ? className : ""}`}>
                    <label htmlFor={name} className={required && "required"}>{label}</label>
                    <DateInput
                        key={name + id}
                        name={name}
                        id={id}
                        placeholder={placeholder}
                        onChange={onChange}
                        required={required}
                        value={value}
                        max="9999-12-31"
                    />
                </div>
            )
        case "select":
            return (
                <div className={`form-input ${name} ${className ? className : ""}`}>
                    <label htmlFor={name} className={required && "required"}>{label}</label>
                    <select
                        key={name + id + (childId !== undefined) && childId}
                        multiple={multiple}
                        onChange={onChange}
                        name={name}
                        value={value || ""}
                    >
                        {(defaultOpt && defaultOptName) ?
                            <option key="default" defaultValue={defaultOpt}>{defaultOptName}</option>
                            : defaultOpt ?
                                <option key="default" value="">Sélectionnez une option</option>
                                : ""
                        }

                        {options.map((option, index) => (
                            <option
                                key={`option` + (index)}
                                value={Object.keys(option)}
                                name={name}
                                defaultValue={value == Object.keys(option)}
                            >{Object.values(option)}
                            </option>
                        ))}
                    </select>
                </div>
            )
        case "checkbox":
            return (
                <div className={`form-input ${name}  ${className ? className : ""} checkbox-type`}>
                    <label htmlFor={name} className={required && "required"}>{label}</label>
                    <input
                        type="checkbox"
                        key={name + id}
                        name={name}
                        checked={value}
                        required={required}
                        onChange={onChange}
                    />
                </div>
            )
        case "radio":
            return (
                <>
                    <div className={`form-input ${className ? className : ""} radio`}>
                        <label htmlFor={name} className={required && "required"}>{label}</label>
                        {options.map(option => (
                            <>
                                <label htmlFor={name + Object.keys(option)}>{Object.values(option)[0]}</label>
                                <input
                                    id={name + Object.keys(option)}
                                    key={name + id}
                                    type="radio"
                                    name={name}
                                    defaultChecked={value == Object.keys(option)}
                                    value={Object.keys(option)}
                                    onChange={onChange}
                                    required={required}
                                />
                            </>
                        ))}
                    </div>
                </>
            )
        case "file":
            return (
                <div className={`form-input ${name}  ${className ? className : "image"}`}>
                    <label htmlFor={name} className={required && "required"}>{label}</label>
                    {(value != "" && (name === "logo" || name === "agencypicture" || name === "image" || name === "imageName"))
                        ? <div className="column">
                            <img src={
                                name === "logo" ?
                                    `${imageFolder}/media/logos/${value}` :
                                    name === "agencypicture" ?
                                        `${imageFolder}/media/agency_pictures/${value}` :
                                        name === "imageName" ?
                                            `${imageFolder}/img/etapes/${value}` :
                                            ""}
                                width="250"
                                height="250"
                                alt={label} />
                            <div>
                                <input
                                    key={name + id}
                                    type="file"
                                    name={name}
                                    onChange={handleFileChange}
                                    required={required}
                                    src={value}
                                />
                                {handleFileUpload && (
                                    <button name={name} className="green-button upl-btn" type="button"
                                        onClick={handleFileUpload}>
                                        <i className="fa fa-upload"></i>
                                        <span>Télécharger</span>
                                    </button>
                                )}
                            </div>
                        </div> :
                        <>
                            <span>Pas de document</span>
                            <div>
                                <input
                                    key={name + id}
                                    type="file"
                                    accept="application/pdf"
                                    name={name}
                                    onChange={handleFileChange}
                                    required={required}
                                    src={value}
                                />
                                {handleFileUpload && (
                                    <button name={name} className="green-button upl-btn" type="button"
                                        onClick={handleFileUpload}>
                                        <i className="fa fa-upload"></i>
                                        <span>Télécharger</span>
                                    </button>
                                )}
                            </div>
                        </>

                    }
                </div>
            );
        case "password":
            return (
                <div className={`form-input ${name}  ${className ? className : ""}`}>
                    <label htmlFor={name} className={required && "required"}>{label}</label>
                    <input
                        key={name + id}
                        type="password"
                        name={name}
                        id={id}
                        value={value}
                        placeholder={placeholder}
                        onChange={onChange}
                        required={required}
                        pattern={pattern}
                    />
                </div>
            )
        default:
            return (
                <div className={`form-input ${name}  ${className ? className : ""}`}>
                    <label htmlFor={name} className={required && "required"}>{label}</label>
                    <input
                        key={name + id}
                        type="text"
                        name={name}
                        id={id}
                        value={value}
                        placeholder={placeholder}
                        onChange={onChange}
                        required={required}
                        pattern={pattern}
                    />
                </div>
            )
    }
}
